var React = require('react');

function IconExternalLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_2304","data-name":"Path 2304","d":"M685.354,360.977H672.191v17.7h17.7V365.416m-9.13,4.956,13.048-13.049v6.766m0-6.764h-6.766","transform":"translate(-671.191 -356.323)","fill":"none","stroke":"#27788C","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"}));
}

IconExternalLink.defaultProps = {"width":"23.618","height":"23.354","viewBox":"0 0 23.618 23.354"};

module.exports = IconExternalLink;

IconExternalLink.default = IconExternalLink;
